import { Autocomplete as MuiAutocomplete, IconButton, Box, TextField } from '@mui/material';
import { colorSet } from '@theme';
import { CSSProperties, useState } from 'react';
import { Text } from '..';
import { SearchGray500Icon, XGray300Icon } from '@assets/iconComponents';

interface ISearchBarProps {
  label?: string;
  boxstyle?: CSSProperties;
  placeholder?: string;
  value: string | null;
  options: string[];
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onAutocompleteChange?: (event: React.SyntheticEvent, value: string | null) => void;
  onClear: () => void;
  onSubmit?: () => void;
}

// 피그마 'Search' 컴포넌트 + 오토컴플리트 기능 제공
export const SearchBar = (props: ISearchBarProps) => {
  const {
    label,
    boxstyle,
    placeholder,
    value,
    options,
    onKeyDown,
    onInputChange,
    onAutocompleteChange,
    onClear,
    onSubmit
  } = props;

  const [openOptions, setOpenOptions] = useState<boolean>(false);

  return (
    <div style={boxstyle}>
      {label ? (
        <Text variant="subtitle" fontWeight="bold" marginBottom="8px">
          {label}
        </Text>
      ) : null}

      <MuiAutocomplete
        className="search-bar-autocomplete" // theme.ts MuiAutocomplete style 적용을 위한 className 부여
        open={openOptions}
        value={value}
        options={options}
        onInputChange={(event, newValue) => {
          if (newValue.length === 0) {
            if (openOptions) {
              setOpenOptions(false);
            }
          } else {
            if (!openOptions) {
              setOpenOptions(true);
            }
          }
        }}
        onChange={(event: React.SyntheticEvent<Element, Event>, value: string | null) => {
          if (onAutocompleteChange) {
            onAutocompleteChange(event, value);
          }
          setOpenOptions(false);
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: value ? (
                  <>
                    <IconButton onClick={onClear}>
                      <XGray300Icon style={{ width: 20, height: 20 }} />
                    </IconButton>
                    <Box
                      style={{
                        height: 32,
                        borderRight: `0.5px solid ${colorSet.gray300}`,
                        marginLeft: 10,
                        marginRight: 12
                      }}
                    />
                    <IconButton
                      onClick={() => {
                        if (onSubmit) {
                          onSubmit();
                        }
                        setOpenOptions(false);
                      }}
                    >
                      <SearchGray500Icon style={{ width: 20, height: 20 }} />
                    </IconButton>
                  </>
                ) : (
                  <SearchGray500Icon style={{ width: 20, height: 20 }} />
                )
              }}
              placeholder={placeholder ?? ''}
              onKeyDown={(e) => {
                if (onKeyDown) {
                  onKeyDown(e);
                }
                if (e.key === 'Enter') {
                  setOpenOptions(false);
                }
              }}
              onChange={onInputChange}
              onFocus={() => setOpenOptions(true)}
              onBlur={() => setOpenOptions(false)}
            />
          );
        }}
      />
    </div>
  );
};
